'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTimer = function MdTimer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 33.4c6.5 0 11.6-5.3 11.6-11.8s-5.1-11.6-11.6-11.6-11.6 5.2-11.6 11.6 5.1 11.8 11.6 11.8z m11.7-21.1c2.1 2.6 3.3 5.8 3.3 9.3 0 8.3-6.7 15-15 15s-15-6.7-15-15 6.7-15 15-15c3.5 0 6.8 1.4 9.4 3.4l2.3-2.4c0.9 0.7 1.7 1.5 2.4 2.3z m-13.3 11.1v-10h3.2v10h-3.2z m6.6-21.8v3.4h-10v-3.4h10z' })
        )
    );
};

exports.default = MdTimer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/timer.js
// module id = 2002
// module chunks = 168707334958949